import http from '@core/fetch'

export default {
  // 档期成员筛选列表
  getGroupMemberList: params =>
    http('/hps/admin/localServerMerchant/fourRole/groupMemberList', {
      body: params
    }),
  // 个人档期筛选
  getScheduleList: params =>
    http('/hps/admin/localServerMerchant/fourRole/scheduleList', {
      body: params
    }),
  // 团队档期筛选
  getMemberScheduleList: params =>
    http('/hps/admin/localServerMerchant/fourRole/memberScheduleList', {
      body: params
    }),
  // 档期时段列表
  getScheduleSlot: params =>
    http('/hps/home/localServerMerchant/fourRole/scheduleSlot', {
      body: params
    }),
  // 检查档期是否冲突
  checkSchedule: params =>
    http('/hps/admin/localServerMerchant/fourRole/checkSchedule', {
      body: params
    }),
  // 新增档期
  addSchedule: params =>
    http.post('/hps/admin/localServerMerchant/fourRole/addSchedule', {
      body: params
    }),
  // 编辑档期
  editSchedule: params =>
    http.post('/hps/admin/localServerMerchant/fourRole/editSchedule', {
      body: params
    }),
  // 档期详情
  getScheduleDetail: params =>
    http('/hps/admin/localServerMerchant/fourRole/scheduleDetail', {
      body: params
    }),
  // 删除档期
  deleteSchedule: params =>
    http.post('/hps/admin/localServerMerchant/fourRole/delSchedule', {
      body: params
    }),
  // 修改档期状态
  changeStatus: params =>
    http.post('/hps/admin/localServerMerchant/fourRole/scheduleStatus', {
      body: params
    })
}
